export default "__VITE_ASSET__c9a83ab1__"